import React from 'react'
import {Button} from 'react-bootstrap'
import {LinkContainer} from 'react-router-bootstrap'
import _ from 'lodash'

export const SyncableButton = (props) => {
  const {
    isSyncing = false,
    didSync = false,
    baseTitle = null,
    isUpdate = false,
    faWaitingImage = 'fa-save',
    className = '',
    ...rest
  } = props

  var newClassName = className

  var title =
    baseTitle != null ? (isUpdate ? 'Update' : 'Save') + ' ' + baseTitle : ''
  var buttonText = (
    <div>
      <i className={'fa ' + faWaitingImage} />
      {title !== '' ? ' ' + title : ''}
    </div>
  )

  if (isSyncing) {
    title = baseTitle != null ? 'Syncing ' + baseTitle : ''
    newClassName = `${newClassName} syncing`
    buttonText = (
      <div>
        <i className="fa fa-spinner fa-spin" />
        {title !== '' ? ' ' + title : ''}
      </div>
    )
  } else if (didSync) {
    title =
      baseTitle != null
        ? baseTitle + ' ' + (isUpdate ? 'Updated!' : 'Saved!')
        : ''
    buttonText = (
      <div>
        <i className="fa fa-check" />
        {title !== '' ? ' ' + title : ''}
      </div>
    )
  }

  return (
    <Button className={newClassName} disabled={isSyncing} {...rest}>
      {buttonText}
    </Button>
  )
}

export const actionButtons = (row, deletingId, editUrl, onDelete) => {
  return (
    <ul className="action-buttons">
      <li
        className="btn btn-primary btn-sm mx-1"
        disabled={!_.isNil(deletingId)}
      >
        <LinkContainer to={editUrl}>
          <i className="fa fa-pencil-alt" />
        </LinkContainer>
      </li>
      <li
        className="btn btn-danger btn-sm mx-1"
        disabled={!_.isNil(deletingId)}
        onClick={() => {
          if (window.confirm("Are you sure you'd like to delete this row?"))
            onDelete(row.id)
        }}
      >
        <i
          className={
            !_.isNil(deletingId) && deletingId === row.id
              ? 'fa fa-spinner fa-spin'
              : 'fa fa-trash-alt'
          }
        />
      </li>
    </ul>
  )
}



// WEBPACK FOOTER //
// ./src/helpers/button.js